import { cn } from "@base/lib/utils";
import { forwardRef } from "react";
import type { HorizontalScrollProps, HorizontalScrollSnapAlign } from "./types";

const snapAlignClass: Record<HorizontalScrollSnapAlign, string> = {
  start: "[&>*]:snap-start",
  center: "[&>*]:snap-center",
  end: "[&>*]:snap-end",
};

export const HorizontalScroll = forwardRef<HTMLDivElement, HorizontalScrollProps>(
  ({ children, className, snap = false, snapAlign = "start" }, ref) => (
    <div
      ref={ref}
      className={cn(
        "hs-scroll flex w-full overflow-x-auto overflow-y-hidden",
        snap && "snap-x snap-mandatory",
        snap && snapAlignClass[snapAlign],
        className,
      )}
    >
      {children}
    </div>
  ),
);

HorizontalScroll.displayName = "HorizontalScroll";

export type { HorizontalScrollProps, HorizontalScrollSnapAlign };
